import { render, staticRenderFns } from "./QTDogRegistrationSignature.vue?vue&type=template&id=28832d06"
import script from "./QTDogRegistrationSignature.vue?vue&type=script&lang=ts"
export * from "./QTDogRegistrationSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports